export const INCOME_DOCUMENTS_STEP_HEADING = 'Income documents';

export const DEFAULT_REQUESTER_NAME = 'The rental manager';

export function templateModeIntro(requesterName: string) {
  return `${requesterName} asked for these documents to support your application. You can submit without them, but they help your application get reviewed faster.`;
}

export const DEFAULT_MODE_INTRO =
  'Add documents that support each income source. They help your application get reviewed faster.';

export function requestedProgressText(covered: number, total: number) {
  return `${covered} of ${total} requested documents have files`;
}

export const INCOME_SOURCE_DOCUMENTS_HEADING = 'Income documents';

export const SUPPORTING_DOCUMENTS_HEADING = 'Supporting documents';

export const OPTIONAL_TAG = 'Optional';

export const ADDITIONAL_FINANCIAL_DOCUMENTS_HEADING = 'Additional financial documents';

export const NO_LONGER_REQUESTED_HEADING = 'No longer requested';

export const NO_LONGER_REQUESTED_TEXT =
  'These files were added for a request that no longer applies to your income sources. They are still saved to your account.';

export const NO_FILES_ADDED = 'No files added';

export const DATE_COVERAGE_NOT_VERIFIED = 'Date coverage is not verified';

export const NO_INCOME_SOURCES_TEXT = 'Add an income source on the Current income step to add documents for it.';

export const REDACTION_TEXT =
  'Sensitive information, like your SSN, may be automatically redacted when you upload a document. Preview your documents to verify that they do not include sensitive information.';

export const PASSWORD_PROTECTED_TEXT = 'Password-protected and encrypted documents are not supported.';

export const STEP_TIP_HEADING = 'Your documents';

export const STEP_TIP_TEXT =
  'Documents that support your income help rental managers verify it. The documents you add are saved to your account.';
